import { BaseRestService } from "../rest/base-rest.service";
export class MfesService extends BaseRestService {
    constructor(window, options) {
        super(window);
        this.options = options;
    }
    async getMfes() {
        var _a;
        return (_a = await this._get(this.options.endpoint, '')) !== null && _a !== void 0 ? _a : [];
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWZlcy5zZXJ2aWNlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3NoYXJlZC9zZXJ2aWNlcy9tZmVzL21mZXMuc2VydmljZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUMsZUFBZSxFQUFDLE1BQU0sMkJBQTJCLENBQUM7QUFJMUQsTUFBTSxPQUFPLFdBQVksU0FBUSxlQUFlO0lBRzVDLFlBQW1CLE1BQWMsRUFBRSxPQUEyQjtRQUMxRCxLQUFLLENBQUMsTUFBTSxDQUFDLENBQUM7UUFDZCxJQUFJLENBQUMsT0FBTyxHQUFHLE9BQU8sQ0FBQztJQUMzQixDQUFDO0lBRU0sS0FBSyxDQUFDLE9BQU87O1FBQ2hCLE9BQU8sTUFBQSxNQUFNLElBQUksQ0FBQyxJQUFJLENBQVksSUFBSSxDQUFDLE9BQU8sQ0FBQyxRQUFRLEVBQUUsRUFBRSxDQUFDLG1DQUFJLEVBQUUsQ0FBQztJQUN2RSxDQUFDO0NBQ0oifQ==